module.exports = __webpack_public_path__ + "img/homebg.d75d0d7c.png";